<template>
	<div class="car-manage">
		<!-- <div class="headCarAdd">
		  	<i class="el-icon-setting"></i>&nbsp;&nbsp;安装包下载管理
		</div> -->
		
		<div class="filter-container">
			<el-date-picker v-model="listQuery.time" type="date"
				placeholder="请选择日期" value-format="yyyy-MM-dd">
			</el-date-picker>
			<el-button class="filter-item" type="primary" icon="el-icon-search" style="margin-left: 10px"
			  @click="handleFilter(true)">
			  搜索
			</el-button>
		</div>
		
		<el-table :data="listData" v-loading="listLoading" border highlight-current-row style="width: 100%; align: center">
			<el-table-column prop="versionType" label="类型" width="140" align="center">
			</el-table-column>
			<el-table-column prop="versionLatest" label="版本类别" width="100" align="center">
			</el-table-column>
			<el-table-column prop="versionName" label="版本名称" width="100" align="center">
			</el-table-column>
			<el-table-column prop="versionCode" label="版本号" width="100" align="center">
			</el-table-column>
			<el-table-column prop="versionUrl" label="下载地址" width="500" align="center">
			</el-table-column>
			<el-table-column prop="versionDescription" label="描述信息"  align="center">
			</el-table-column>
			<el-table-column prop="versionTime" label="创建日期" align="center"  >
			</el-table-column>
			<el-table-column prop="operator" label="操作" align="center" >
				<template v-slot:="{row,$index}">
					<!-- <el-button type="primary" size="mini" @click="handleDownload(row)">
						下载
					</el-button> -->
					<el-link target="_blank" :href="row.versionUrl" :underline="false">
					   <el-button size="mini" type="primary">下载</el-button>
					 </el-link>
				</template>
			</el-table-column>
		</el-table>
		
	</div>
</template>

<script>
	import Pagination from '@/components/common/Pagination'
	import {formatDate} from '@/utils/date'
	import {versionList} from '@/api/appManage.js'
	
	export default {
		name: 'ApkManage',
		components: {
		    Pagination,
		},
		data(){
		    return{
		        listLoading: true,
		        listData: [],
		        totalCounts: 0,
		        listQuery: {
		            pageIndex: 1,
		            pageSize: 10,
		            params: {
		                
		            },
		            fuzzySearch: true,
					time:undefined,
		        },
		    }//-return
		},
		methods:{
			handleFilter() {
			    this.listLoading = true
			    versionList(this.listQuery).then(res => {
			        let data = res.pageData
			        this.totalCounts = data.totalCounts
			        // 对后端数据进行解析
			        this.listData = data.datas.map(item => {
			            item.versionTime=formatDate(item.versionTime)
						item.versionLatest =  item.versionLatest === 0 ? '最新版' : '历史版'
						item.versionType = item.versionType === 0 ? '管理员版本' : '用户版本'
			            return item
			        })
			        this.listLoading = false
			    })
			},
			handlePageChange(data) {
			    this.listQuery.pageIndex = data.page
			    this.listQuery.pageSize = data.limit
			    this.handleFilter()
			},
			handleReply(row){
			    window.open('https://chat.techinao.com/main')
			},
		}, //-methods
		mounted(){
		    this.handleFilter()
		},
		
		handleDownload(row){
			
		}
	}
	
</script>

<style>
.headCarAdd{
		background-color:#3fb976;
		width:100%;
		height:50px;
		color:#FFFFFF;
		line-height:50px;
		padding-left: 15px;
		border-radius: 10px;
	}
</style>
